import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCMlDrckoGSmjBedojs_cdAkCE_q-EjDo0",
  authDomain: "speeddigits-trainer.firebaseapp.com",
  projectId: "speeddigits-trainer",
  storageBucket: "speeddigits-trainer.firebasestorage.app",
  messagingSenderId: "155071670090",
  appId: "1:155071670090:web:7fadd9084c4d487e6403b3",
  measurementId: "G-44G1285NRQ",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
